import React, { useMemo } from "react";
import queryString from "query-string";
import { useParams, Redirect } from "react-router-dom";
import { ConnectedLoginForm } from "./ConnectedLoginForm";
import identitySelectors from "../../../selectors/identity";

import PublicAuthFormWrapper from "./PublicAuthFormWrapper";
import AppSettings from "../../../config.js";
import { useSelector } from "react-redux";

export const PublicLogin = (props: any) => {
  const { site } = useParams<{ site: string }>();
  const query = useMemo(() => queryString.parse(props.location.search), [props.location.search]);
  const isLoggedIn = useSelector(identitySelectors.isLoggedIn);
  const isCitizen = useSelector(identitySelectors.isCitizen);

  if (isLoggedIn) {
    const redirect = query.redirect as string | undefined;
    // Don't try to redirect citizens to non-public routes
    if (!(redirect?.includes("public") || !isCitizen) && !redirect?.includes(AppSettings.GOGOV_WEB_URL))
      return <Redirect to={`/${site}`} />;
    // When the redirect is a full URL, not a relative path
    if (query.redirect?.includes("http")) {
      window.location.href = query.redirect as string;
      return null;
    }
    return <Redirect to={redirect || `/${site}`} />;
  }

  return (
    <PublicAuthFormWrapper title='Sign In' documentTitle='Sign into your account'>
      <ConnectedLoginForm site={site} usernameLabel='Email' />
    </PublicAuthFormWrapper>
  );
};

export default PublicLogin;
